import MultiDropDown from '../../../../../../components/MultiDropDown';
import moment from 'moment';
import {
  faCheck,
  faAward,
  faUserMinus,
  faUserGraduate,
  faThumbsUp,
  /*faCircleQuestion,*/
  faCalculator,
  faAngle,
  faVolumeHigh,
  faVolumeSlash,
  faRetweet,
  faUpload,
  faCameraSlash,
  faClock,
  faLanguage,
  faLock,
  faMessagesQuestion,
  faChartArea,
  faSort,
  faShuffle,
  faEye,
  faEyeSlash,
  faCalendarDays,
  faEraser,
  faLockA,
  faAlarmExclamation,
  faTimer,
  faLockKeyhole,
  faLockKeyholeOpen,
  faShieldKeyhole,
  faPaperclip
} from '@fortawesome/pro-solid-svg-icons';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import React from 'react';
import { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/pro-light-svg-icons';
import { Form, Accordion, OverlayTrigger, Tooltip, Modal, Button } from 'react-bootstrap';
import RetakesModal from './components/retakeResultsModal';
import FloatingMenu from '../../../../../../components/floatingMenu/floatingMenu';
import {
  useUnassignStudentsMutation,
  usePushGradesMutation,
  useSetAssignmentToReviewMutation,
  useLazyGetAssignmentQuery
} from '../../../../../../features/authentication/assignmentApislice';
import HesSpinner from '../../../../../../components/loadingOverlay/hesSpinner';
import { useNavigate } from 'react-router-dom';
import ConfirmUnassign from '../../../../../../assets/images/confirmUnassign.png';
import StudentClipboardImg from '../../../../../../assets/images/studentClipboard.png';
import CustomToast from '../../../../../../components/Toast/index';
import { useSelector } from 'react-redux';
import {
  selectFerpaState,
  selectCurrentToken
} from '../../../../../../features/authentication/authSlice';
import { useAssignmentContext } from '../../../../context';
import UiVirtualScroll from '../../../../../../components/VirtualScroll';
import ConfirmationModal from '../../../../../../../src/components/ConfirmationPopUp';
import appConfig from '../../../../../../app-config';
import { useSetClassFiltersMutation } from '../../../../../../features/authentication/assignApiSlice';
import StudentUploadedFilesModal from './CRGrading/components/studentUploadedFilesModal';

function generateAssignmentDetails(assignmentOptions, index, optionsPerRow) {
  let assignmentDetails = [];

  switch (assignmentOptions.mode) {
  case 0:
  case 4:
  case 6:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
              Assignment Mode: Open
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#48E0B2', backgroundColor: '#E3FFF6' }}>
            Open
        </div>
      </OverlayTrigger>
    );
    break;
  case 2:
  case 7:
  case 8:
  case 9:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
              Assignment Mode: Quiz
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#A29BFE', backgroundColor: '#E9E9FD' }}>
            Quiz
        </div>
      </OverlayTrigger>
    );
    break;
  case 1:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
              Assignment Mode: Locked
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#F84646', backgroundColor: '#FFE3E3' }}>
            Locked
        </div>
      </OverlayTrigger>
    );
    break;
  case 3:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
              Assignment Mode: Review
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#FFA800', backgroundColor: '#FFF4E3', fontSize: '1em' }}>
            Review
        </div>
      </OverlayTrigger>
    );
    break;
  case 5:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
              Assignment Mode: Offline
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#525252', backgroundColor: '#F0F2F8' }}>
            Offline
        </div>
      </OverlayTrigger>
    );
    break;
  case 11:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentMode-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentMode-${index}`} className="custom-tooltip">
              Assignment Mode: GradeCam
          </Tooltip>
        }>
        <div
          className="assignmentOptions"
          style={{ color: '#82A9E2', backgroundColor: '#E4EFFC' }}>
            GradeCam
        </div>
      </OverlayTrigger>
    );
    break;
  }

  switch (assignmentOptions.mode) {
  case 2:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentModeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
              Show grade upon completion of quiz
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#E3FFF6' }}>
          <FontAwesomeIcon icon={faEye} color="#48E0B2" />
        </div>
      </OverlayTrigger>
    );
    break;
  case 6:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentModeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
              Automatically lock questions
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faLockA} color="#F84646" />
        </div>
      </OverlayTrigger>
    );
    break;
  case 8:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentModeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
              Allow changes to answers
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFF2F7' }}>
          <FontAwesomeIcon icon={faEraser} color="#FD79A8" />
        </div>
      </OverlayTrigger>
    );
    break;
  case 9:
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentModeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentModeOption-${index}`} className="custom-tooltip">
            {'Don\'t show grade upon completion of quiz'}
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faEyeSlash} color="#F84646" />
        </div>
      </OverlayTrigger>
    );
    break;
  }

  // Past Due
  if (assignmentOptions.timedOut)
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentTimedOut-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentTimedOut-${index}`} className="custom-tooltip">
            Past due
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faAlarmExclamation} color="#F84646" />
        </div>
      </OverlayTrigger>
    );

  // From/To
  if (assignmentOptions.mode == 4 || assignmentOptions.availability) {
    var dateTimeOptions = {
      month: '2-digit',
      day: '2-digit',
      year: '2-digit',
      hour: 'numeric',
      minute: '2-digit'
    };
    assignmentDetails.push(
      <OverlayTrigger
        key={`assignmentTimedOut-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-assignmentTimedOut-${index}`} className="custom-tooltip">
            From/To
            <br />
            {`${new Date(assignmentOptions.availability.startDate).toLocaleString(
              'en-US',
              dateTimeOptions
            )} - ${new Date(assignmentOptions.availability.endDate).toLocaleString(
              'en-US',
              dateTimeOptions
            )}`}
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#D9F6FF' }}>
          <FontAwesomeIcon icon={faCalendarDays} color="#09BCF3" />
        </div>
      </OverlayTrigger>
    );
  }

  // Timed
  if (assignmentOptions.timeLimit) {
    var duration = moment.duration(assignmentOptions.timeLimit);
    console.log(duration.hours());
    assignmentDetails.push(
      <OverlayTrigger
        key={`timed-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-timedOption-${index}`} className="custom-tooltip">
            Assignment is timed:{' '}
            {`${duration.hours() > 0 ? duration.hours() + 'h' : ''} ${duration.minutes()}m`}
          </Tooltip>
        }>
        <div className="assignmentOptions assignmentOptionsIcon">
          <FontAwesomeIcon color="#82A9E2" icon={faTimer} />
        </div>
      </OverlayTrigger>
    );
  }

  // On screen calculator
  if (assignmentOptions.onScreenCalculator)
    if (assignmentOptions.calculatorType === 1) {
      assignmentDetails.push(
        <OverlayTrigger
          key={`calculatorOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-calculatorOption-${index}`} className="custom-tooltip">
              A 4 Fucntion Calculator is available on screen for this assignment
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: 'lightpink' }}>
            <FontAwesomeIcon color="red" icon={faCalculator} />
          </div>
        </OverlayTrigger>
      );
    } else if (assignmentOptions.calculatorType === 2) {
      assignmentDetails.push(
        <OverlayTrigger
          key={`calculatorOption-${index}`}
          placement="top"
          overlay={
            <Tooltip id={`tooltip-calculatorOption-${index}`} className="custom-tooltip">
              A Scientific Calculator is available on screen for this assignment
            </Tooltip>
          }>
          <div className="assignmentOptions" style={{ backgroundColor: '#E4EFFC' }}>
            <FontAwesomeIcon color="#82A9E2" icon={faCalculator} />
          </div>
        </OverlayTrigger>
      );
    }

  // On screen protractor
  if (assignmentOptions.onScreenProtractor)
    assignmentDetails.push(
      <OverlayTrigger
        key={`protractorOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-protractorOption-${index}`} className="custom-tooltip">
            A protractor is available on screen for this assignment
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#F4FBE8' }}>
          <FontAwesomeIcon color="#88D111" icon={faAngle} />
        </div>
      </OverlayTrigger>
    );

  // Randomized questions
  if (assignmentOptions.questionsRandomized)
    assignmentDetails.push(
      <OverlayTrigger
        key={`randomizedOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-randomizedOption-${index}`} className="custom-tooltip">
            Questions are Randomized
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFF2F7' }}>
          <FontAwesomeIcon color="#FD79A8" icon={faShuffle} />
        </div>
      </OverlayTrigger>
    );

  // Re-takes enabled
  if (assignmentOptions.retakes)
    assignmentDetails.push(
      <OverlayTrigger
        key={`retakeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-retakeOption-${index}`} className="custom-tooltip">
            Retakes Enabled
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#F2E5FF' }}>
          <FontAwesomeIcon icon={faRetweet} color="#9E5CDF" />
        </div>
      </OverlayTrigger>
    );

  // Text to speech enabled
  if (assignmentOptions.textToSpeech) {
    assignmentDetails.push(
      <OverlayTrigger
        key={`textToSpeechOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-textToSpeechOption-${index}`} className="custom-tooltip">
            Text-to-Speech Enabled
          </Tooltip>
        }>
        <div className='assignmentOptions bg-lightgreen'>
          <FontAwesomeIcon icon={faVolumeHigh} className='success-icon-btn' />
        </div>
      </OverlayTrigger>
    );

    // Text to speech disabled
  } else {
    assignmentDetails.push(
      <OverlayTrigger
        key={`textToSpeechOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-textToSpeechOption-${index}`} className="custom-tooltip">
            Text-to-Speech Disabled
          </Tooltip>
        }>
        <div className='assignmentOptions bg-lightred'>
          <FontAwesomeIcon icon={faVolumeSlash} className='danger-icon-btn' />
        </div>
      </OverlayTrigger>
    );
  }

  // Time on task
  if (assignmentOptions.timeOnTask)
    assignmentDetails.push(
      <OverlayTrigger
        key={`timeOnTaskOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-timeOnTaskOption-${index}`} className="custom-tooltip">
            The amount of time the student takes answering questions will be tracked
            <br />
            {`Maximum Time Per Question: ${assignmentOptions.timeOnTask}`}
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#D9F6FF' }}>
          <FontAwesomeIcon icon={faClock} color="#09BCF3" />
        </div>
      </OverlayTrigger>
    );

  // Photomath blocker
  if (assignmentOptions.photomathBlocker)
    assignmentDetails.push(
      <OverlayTrigger
        key={`photomathBlockerOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-photomathBlockerOption-${index}`} className="custom-tooltip">
            Photomath Blocker Enabled
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faCameraSlash} color="#F84646" />
        </div>
      </OverlayTrigger>
    );

  // Language change
  if (assignmentOptions.allowLanguageChange)
    assignmentDetails.push(
      <OverlayTrigger
        key={`languageChangeOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-languageChangeOption-${index}`} className="custom-tooltip">
            The student will be allowed to change the display language while taking this assignment
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#E3FFF6' }}>
          <FontAwesomeIcon icon={faLanguage} color="#48E0B2" />
        </div>
      </OverlayTrigger>
    );

  // Browser lockdown
  if (assignmentOptions.browserLockdown)
    assignmentDetails.push(
      <OverlayTrigger
        key={`browserLockOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-browserLockOption-${index}`} className="custom-tooltip">
            The student will not be allowed have other browser tabs or windows open while taking
            this assignment.
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#FFE3E3' }}>
          <FontAwesomeIcon icon={faLock} color="#F84646" />
        </div>
      </OverlayTrigger>
    );

  // Student Upload File
  if (assignmentOptions.studentUploadFiles)
    assignmentDetails.push(
      <OverlayTrigger
        key={`studentFileUploadOption-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-studentFileUploadOption-${index}`} className="custom-tooltip">
            Student is allowed to upload files
          </Tooltip>
        }>
        <div className="assignmentOptions" style={{ backgroundColor: '#E4EFFC' }}>
          <FontAwesomeIcon icon={faUpload} color="#82A9E2" />
        </div>
      </OverlayTrigger>
    );
  if (assignmentOptions.locked)
    assignmentDetails.push(
      <OverlayTrigger
        key={`locked-${index}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-studentFileUploadOption-${index}`} className="custom-tooltip">
            Locked
          </Tooltip>
        }>
        <div className="assignmentOptions assignmentOptionsIcon">
          <FontAwesomeIcon icon={faUpload} color="#82A9E2" />
        </div>
      </OverlayTrigger>
    );

  let detailRows = [];
  var keyIndex = 0;
  do {
    detailRows.push(
      <div
        key={`optionRow${index}${keyIndex}`}
        className={`d-flex flex-row ${keyIndex > 0 ? 'mt-2' : ''}`}>
        {assignmentDetails.splice(0, optionsPerRow).map((assignmentOption) => {
          return assignmentOption;
        })}
      </div>
    );
    keyIndex++;
  } while (assignmentDetails.length > 0);

  return <div className="d-flex flex-column">{detailRows}</div>;
}

function AssignmentResults() {
  const studentFilesModalData = useRef(null);
  const baseUrl = appConfig.apiBaseUrl;
  const token = useSelector(selectCurrentToken);
  const [showLock, setShowLock] = useState(false);
  const [studentsSelected, setStudentsSelected] = useState(false);
  const [confirmModel, setConfirmModel] = useState(false);
  const [showRemovedStudents, setShowRemovedStudents] = useState(false);
  const [showPoints, setShowPoints] = useState(true);
  const [retryCreditId, setRetryCreditId] = useState(0);
  const [scoreUnansweredAsZero, setScoreUnansweredAsZero] = useState(false);
  const sortByAscending = useRef(true);
  const sortResultsBy = useRef('sort-lastName');
  const [selectedClassIds, setSelectedClassIds] = useState([]);
  const [classList, setClassList] = useState([]);
  const [displayResults, setDisplayResults] = useState([]);
  const [showRetakesModal, setShowRetakesModal] = useState(false);
  const [showConfirmUnassignModal, setShowConfirmUnassignModal] = useState(false);
  const retakeModalData = useRef(null);
  const retakeScore = useRef(null);
  const navigate = useNavigate();
  let pageNumber = 0;
  const { assignmentId, setClasses, assignmentAssignedViaDetails, assignmentName } =
    useAssignmentContext();
  const [trigger, result] = useLazyGetAssignmentQuery({
    assignmentId: assignmentId,
    pageNumber: pageNumber
  });
  const [unassignStudents, unassignStudentsResult] = useUnassignStudentsMutation();
  const [pushGrades] = usePushGradesMutation();
  const [setAssignmentToReview, setAssignmentToReviewResults] = useSetAssignmentToReviewMutation();
  const ferpaEnabled = useSelector(selectFerpaState);
  const [showConfirmReviewModal, setShowConfirmReviewModal] = useState(false);
  const [setclassFilter] = useSetClassFiltersMutation();
  const [initialLoad, setInitialLoad] = useState(true);
  const [showStudentFilesModal, setShowStudentFilesModal] = useState(false);
  const [floatingMenuButtons, setFloatingMenuButtons] = useState([
    {
      id: 1,
      name: 'CR Grading',
      tooltip: 'Grade CR questions for this assignment',
      icon: <FontAwesomeIcon icon={faAward} />,
      disabled: true,
    },
    {
      id: 2,
      name: 'Unassign Assignment',
      tooltip: 'This option allows you to unassign the Original Assignment.',
      icon: <FontAwesomeIcon icon={faUserMinus} />,
      disabled: true,
    },
    {
      id: 4,
      name: 'Set to Review Only (Includes any Retakes)',
      tooltip: 'Set to Review Only (Includes any Retakes)',
      icon: <FontAwesomeIcon icon={faThumbsUp} />,
      disabled: true,
    }
  ]);

  const handleClick = (floatId) => {
    switch (floatId) {
    case 1:
      handleCrGrading();
      break;
    case 2:
      setShowConfirmUnassignModal(true);
      break;
    case 3:
      handlePushGrades();
      break;
    case 4:
      setShowConfirmReviewModal(true);
      break;
    }
  };

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (!initialLoad) {
      setClassIdsFilter();
    }
  }, [selectedClassIds]);

  const setClassIdsFilter = async () => {
    try {
      await setclassFilter(selectedClassIds).unwrap();
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (ferpaEnabled) {
      let randomSort = [...displayResults];
      randomSort.sort(() => Math.random() - 0.5);
      setDisplayResults(randomSort);
    } else {
      handleAssignmentSort();
    }
  }, [ferpaEnabled]);

  function refetch() {
    trigger({ assignmentId: assignmentId, pageNumber: pageNumber }).then((response) => {
      if (!response.isSuccess) {
        return;
      }
      setStudentsSelected(false);
      const persistClassIds = response.data.classes
        .filter((obj) => obj.selected)
        .map((obj) => obj.id);
      setSelectedClassIds(persistClassIds);
      setInitialLoad(false);
      setDisplayResults(response.data.assignmentResults);

      var tempArray = [...floatingMenuButtons];
      tempArray = tempArray.map((button) => {
        return button.id == 1 ? button : { ...button, disabled: true };
      });
      switch (assignmentAssignedViaDetails.id) {
      case 2:
        tempArray.splice(2, 0, {
          id: 3,
          name: 'Push Grade to Google Classroom',
          tooltip: 'Push grades to Google Classroom',
          icon: <FontAwesomeIcon icon={faGoogle} />,
          disabled: true
        });
        console.log('Set Floating menu buttons');
        break;
      case 3:
      case 4:
        tempArray.splice(2, 0, {
          id: 3,
          name: `Push Grades to ${assignmentAssignedViaDetails.name}`,
          tooltip: `Push Grades to ${assignmentAssignedViaDetails.name}`,
          icon: <FontAwesomeIcon icon={faUserGraduate} />,
          disabled: true
        });
        break;
      }
      if (response.data.includesCRQuestions) {
        tempArray[0].disabled = false;
      }
      setFloatingMenuButtons(tempArray);

      setClasses(response.data.classes);

      setClassList(
        response.data.classes.map((item) => {
          return {
            name: item.name,
            id: item.id,
            description: item.coTeacherName,
            isChecked: item.selected
          };
        })
      );
    });
  }

  const handleCrGrading = () => {
    navigate(`/assignments/${assignmentId}/grade_constructiveResponses`);
  };

  async function handleSetAssignmentToReview() {
    try {
      var selectedStudentIds = displayResults
        .filter((s) => s.isChecked == true)
        .map((s) => s.studentId);
      var reviewResult = await setAssignmentToReview({
        originalAssignmentId: assignmentId,
        studentIds: selectedStudentIds
      }).unwrap();

      setShowConfirmReviewModal(false);

      if (reviewResult.length == selectedStudentIds.length) {
        CustomToast('Original and retake assignments set to review', 'success');
      } else {
        CustomToast('Not all original and retake assignments set to review', 'warning');
      }
      refetch();
    } catch (ex) {
      CustomToast('Something went wrong trying to set assignment(s) to review', 'error');
      console.log(ex);
    }
  }

  async function handleUnassignStudents() {
    try {
      var selectedStudents = displayResults
        .filter((s) => s.isChecked == true)
        .map((s) => s.studentId);

      await unassignStudents({ assignmentId: assignmentId, studentIds: selectedStudents }).unwrap();
      setShowConfirmUnassignModal(false);
      refetch();
      CustomToast(`${selectedStudents.length} have been removed from the assignment`, 'success');
    } catch {
      CustomToast('Something went wrong trying to unassign the assignment', 'error');
    }
  }

  const handlePushGrades = async () => {
    try {
      var pushGradesModel = {
        assignmentId: assignmentId,
        pushGradesToId: result?.assignedVia?.id,
        scoreRetriesOptionId: retryCreditId,
        scoreUnansweredAsZero: scoreUnansweredAsZero,
        studentIds: displayResults.filter((s) => s.isChecked == true).map((s) => s.studentId)
      };

      var pushedStudents = await pushGrades(pushGradesModel).unwrap();

      if (pushedStudents.success == false) {
        if (pushedStudents.redirectUrl) {
          window.open(pushedStudents.redirectUrl, '_blank');
          CustomToast('Google login required', 'warning');
          return;
        }
        CustomToast(pushedStudents.reason, 'error');
        return;
      }

      if (pushedStudents.studentsPushed.length == pushGrades.studentIds.length) {
        CustomToast('All grades pushed successfully', 'success');
      } else {
        CustomToast('Not all grades were pushed', 'warning');
      }
      refetch();
    } catch (ex) {
      console.log(ex);
      CustomToast(
        `Something went wrong trying to push grades to ${result.assignedVia.name}`,
        'error'
      );
    }
  };

  const handleAssignmentSort = (e) => {
    let sortedAssignmentResults = [...displayResults];
    if (e) sortByAscending.current = !sortByAscending.current;
    switch (sortResultsBy.current) {
    case 'sort-lastName':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.studentLastName > b.studentLastName ? 1 : -1
      );
      break;
    case 'sort-firstName':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.studentFirstName > b.studentFirstName ? 1 : -1
      );
      break;
    case 'sort-className':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.className > b.className ? 1 : -1
      );
      break;
    case 'sort-crAnsweredCount':
      sortedAssignmentResults = sortedAssignmentResults.sort(
        (a, b) => a.crAnsweredCount - b.crAnsweredCount
      );
      break;
    case 'sort-rawScore':
      switch (retryCreditId) {
      case 0:
        if (showPoints) {
          sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
            a.retriesAsNoCreditScore?.point > b.retriesAsNoCreditScore?.point ? 1 : -1
          );
        } else {
          if (scoreUnansweredAsZero) {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              a.retriesAsNoCreditScore?.percentUnansweredAsZero >
                    b.retriesAsNoCreditScore?.percentUnansweredAsZero
                ? 1
                : -1
            );
          } else {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              a.retriesAsNoCreditScore?.percent > b.retriesAsNoCreditScore?.percent ? 1 : -1
            );
          }
        }
        break;
      case 1:
        if (showPoints) {
          sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
            a.retriesAsHalfCreditScore?.point > b.retriesAsHalfCreditScore?.point ? 1 : -1
          );
        } else {
          if (scoreUnansweredAsZero) {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              a.retriesAsHalfCreditScore?.percentUnansweredAsZero >
                    b.retriesAsHalfCreditScore?.percentUnansweredAsZero
                ? 1
                : -1
            );
          } else {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              a.retriesAsHalfCreditScore?.percent > b.retriesAsHalfCreditScore?.percent ? 1 : -1
            );
          }
        }
        break;
      case 2:
        if (showPoints) {
          sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
            a.retriesAsFullCreditScore?.point > b.retriesAsFullCreditScore?.point ? 1 : -1
          );
        } else {
          if (scoreUnansweredAsZero) {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              a.retriesAsFullCreditScore?.percentUnansweredAsZero >
                    b.retriesAsFullCreditScore?.percentUnansweredAsZero
                ? 1
                : -1
            );
          } else {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              a.retriesAsFullCreditScore?.percent > b.retriesAsFullCreditScore?.percent ? 1 : -1
            );
          }
        }
        break;
      default:
        if (showPoints) {
          sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
            a.retriesAsNoCreditScore?.point > b.retriesAsNoCreditScore?.point ? 1 : -1
          );
        } else {
          if (scoreUnansweredAsZero) {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              a.retriesAsNoCreditScore?.percentUnansweredAsZero >
                    b.retriesAsNoCreditScore?.percentUnansweredAsZero
                ? 1
                : -1
            );
          } else {
            sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
              a.retriesAsNoCreditScore?.percent > b.retriesAsNoCreditScore?.percent ? 1 : -1
            );
          }
        }
      }

      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.className > b.className ? 1 : -1
      );
      break;
    case 'sort-retakeBestScore':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.masteryScore > b.masteryScore ? 1 : -1
      );
      break;
    case 'sort-dateAssigned':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.dateAssigned > b.dateAssigned ? 1 : -1
      );
      break;
    case 'sort-dateStarted':
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.dateStarted > b.dateStarted ? 1 : -1
      );
      break;
    case 'sort-dateCompleted':
      break;
    default:
      sortedAssignmentResults = sortedAssignmentResults.sort((a, b) =>
        a.studentLastName > b.studentLastName ? 1 : -1
      );
    }
    if (!sortByAscending.current) sortedAssignmentResults.reverse();

    setDisplayResults(sortedAssignmentResults);
  };

  const handleAssignmentChecked = (e) => {
    const { name, checked } = e.target;
    let tempAssignmentResults = [...displayResults];

    if (name === 'allselect') {
      tempAssignmentResults = tempAssignmentResults.map((item) => {
        return { ...item, isChecked: checked };
      });
    } else {
      tempAssignmentResults = tempAssignmentResults.map((item) =>
        item.studentId == name ? { ...item, isChecked: checked } : item
      );
    }
    setDisplayResults(tempAssignmentResults);
    let tempButtons = [...floatingMenuButtons];
    const disableButtons = tempAssignmentResults.filter((s) => s.isChecked == true).length == 0;
    setStudentsSelected(!disableButtons);
    tempButtons = tempButtons.map((button) => {
      return button.id == 1 ? button : { ...button, disabled: disableButtons };
    });
    setFloatingMenuButtons(tempButtons);
  };

  const handleClassSelectionChange = (e) => {
    const { key } = e;
    const selected = key !== '000' ? classList.find((v) => v.id == key) : classList;
    let tempValue = [];

    if (key === '000') {
      tempValue = classList.map((item) => ({
        ...item,
        isChecked: !classList.filter((item) => item?.isChecked !== true).length < 1
      }));
    } else {
      tempValue = classList.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }
    setClassList(tempValue);
    const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
    setSelectedClassIds(ids);

    let tempButtons = [...floatingMenuButtons];
    const disableButtons =
      displayResults.filter((item) => ids.includes(item.classId) && item.isChecked == true)
        .length == 0;
    tempButtons = tempButtons.map((button) => {
      return button.id == 1 ? button : { ...button, disabled: disableButtons };
    });
    setFloatingMenuButtons(tempButtons);

    let tempResults = [...displayResults];
    tempResults = tempResults.map((result) => {
      return result.isChecked == false
        ? result
        : { ...result, isChecked: ids.includes(result.classId) };
    });
    setDisplayResults(tempResults);
  };

  useEffect(() => {
    if (
      displayResults.length == 0 ||
      displayResults.filter((item) => selectedClassIds.includes(item.classId)).length == 0 ||
      (!showRemovedStudents && displayResults.filter((item) => !item.isRemoved).length == 0)
    ) {
      setShowLock(false);
    } else {
      setShowLock(true);
    }
  }, [displayResults]);

  const reportNavigateHandler = (studentId, assignmentId, name, scoreUnansweredAsZero) => {
    navigate(`/assignments/${assignmentId}/manage_assign/reports/student_session_report?studentId=${studentId}&incompleteScoring=${scoreUnansweredAsZero}`, {
      state: { className: name }
    });
  };
  const lockStudents = () => {
    !studentsSelected
      ? CustomToast('Please check at least one student.', 'info')
      : setConfirmModel(true);
  };
  const updateSelectedStudentLock = async () => {
    var selectedStudents = displayResults
      .filter((s) => s.isChecked == true)
      .map((s) => s.studentId);
    updateLockedStatus(selectedStudents);
  };
  const updateIndividualStudentLock = (studentId) => {
    updateLockedStatus([studentId]);
  };
  const updateLockedStatus = async (selectedStudents) => {
    let url = baseUrl + `/Assignment/${assignmentId}/LockStatus`;
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
    const lockedResponse = await fetch(url, {
      headers,
      method: 'PUT',
      body: JSON.stringify(selectedStudents)
    });
    if (lockedResponse.status == 200) {
      refetch();
      setConfirmModel(false);
      CustomToast('Assignment Mode Changed Successfully', 'success');
    } else {
      const errorMsg = await lockedResponse.text();
      CustomToast(`${errorMsg}`, 'error');
      setConfirmModel(false);
    }
  };

  const getRetakeScorePercentage = (studentResult) => {
    let points = studentResult.retriesAsNoCreditScore?.points ?? 0;
    if (studentResult.retakeResults) {
      let retakes = studentResult.retakeResults.filter((retake) => retake.sessionId > 0);
      retakes.map((retake) => {
        points += retake.retriesAsNoCreditScore?.points ?? 0;
      });
    }
    return {
      points: points,
      percent: Math.round((points / result.data?.questionsCount) * 100)
    };
  };

  return (
    <>
      <StudentUploadedFilesModal
        studentFilesData={studentFilesModalData.current}
        assignmentName={assignmentName}
        show={showStudentFilesModal}
        onHide={() => setShowStudentFilesModal(false)}
        isFerpa={!ferpaEnabled}
      />
      <ConfirmationModal
        isOpen={confirmModel}
        onClose={() => setConfirmModel(false)}
        onSave={() => updateSelectedStudentLock()}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={
          'This would LOCK selected student assignment that is unlocked and UNLOCK selected student assignment that is locked. Are you sure want to continue?'
        }
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
      <div className="d-flex flex-row align-items-center">
        <Form.Group className="w-25" style={{ marginRight: '0.5vw' }}>
          <Form.Label htmlFor="classDropdown">Class</Form.Label>

          <MultiDropDown
            value={classList}
            setValue={setClassList}
            dropdownId="classesFilter"
            placeholder="Filter Classes"
            handleChange={(e) => handleClassSelectionChange(e)}
            selectedId={selectedClassIds}
            setSelectedId={setSelectedClassIds}
            description={true}
            selectAllText="All Classes"
            coteachertext={true}
          />
        </Form.Group>
        <div className="w-100" style={{ marginTop: '35px' }}>
          <Form.Check
            type="checkbox"
            id="displayRemovedStudents"
            className="d-flex flex-row align-items-center">
            <Form.Check.Input
              type="checkbox"
              defaultChecked={showRemovedStudents}
              checked={showRemovedStudents}
              style={{ marginRight: '5px' }}
              onChange={() => setShowRemovedStudents(!showRemovedStudents)}
            />
            <Form.Check.Label>Display Removed Students</Form.Check.Label>
          </Form.Check>
        </div>
      </div>

      <Accordion className="d-flex flex-row mt-4 mb-5 accordion-castleShaded " defaultActiveKey="0">
        <Accordion.Item className="w-100" eventKey="0">
          <Accordion.Header>
            <h1 style={{ margin: '0px' }} className="text-color">
              Score Options
            </h1>
          </Accordion.Header>
          <Accordion.Body className="d-flex flex-column">
            <div className="d-flex flex-row">
              <div className="d-flex flex-column">
                <Form.Label
                  style={{ fontSize: '14px', fontWeight: '500' }}
                  className="text-color"
                  htmlFor="scoreAsRadio">
                  Show score as
                </Form.Label>
                <Form.Group id="scoreAsRadio">
                  <Form.Check
                    inline
                    label="Points"
                    name="scoreGroup"
                    type="radio"
                    id="pointsRadio"
                    defaultChecked="true"
                    onChange={() => setShowPoints(true)}
                  />
                  <Form.Check
                    inline
                    label="Percent"
                    name="scoreGroup"
                    type="radio"
                    id="percentRadio"
                    onChange={() => setShowPoints(false)}
                  />
                </Form.Group>
              </div>

              <div className="d-flex flex-column mx-3">
                <Form.Label
                  style={{ fontSize: '14px', fontWeight: '500' }}
                  className="text-color"
                  htmlFor="retriesRadio">
                  Retries
                </Form.Label>
                <Form.Group id="retriesRadio">
                  <Form.Check
                    inline
                    label="Score with retries as no credit"
                    name="retriesGroup"
                    type="radio"
                    id="noCreditRadio"
                    defaultChecked="true"
                    onChange={() => setRetryCreditId(0)}
                  />
                  <Form.Check
                    inline
                    label="Score with retries as half credit"
                    name="retriesGroup"
                    type="radio"
                    id="halfCreditRadio"
                    onChange={() => setRetryCreditId(1)}
                  />
                  <Form.Check
                    inline
                    label="Score with retries as full credit"
                    name="retriesGroup"
                    type="radio"
                    id="fullCreditRadio"
                    onChange={() => setRetryCreditId(2)}
                  />
                </Form.Group>
              </div>
            </div>

            <Form.Check
              className="mt-3"
              type="checkbox"
              id="scoreUnansweredQuestions"
              label="Score unanswered short answer questions as Incorrect and unscored/unanswered CR questions as 0 points"
              defaultChecked={false}
              onChange={() => setScoreUnansweredAsZero(!scoreUnansweredAsZero)}
            />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <div className="d-flex flex-row justify-content-between">
        <h1>
          Assignment Results {/*<FontAwesomeIcon icon={faCircleQuestion} color="#88CBF1" /> */}
        </h1>
        <div className="d-flex flex-row">
          {showLock && (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className="modal-title-tooltip">
                  Select a student/students to lock or
                  <br /> unlock their assignment
                </Tooltip>
              }>
              <button
                className="lockIcon btn-link primary-link px-3"
                onClick={() => {
                  lockStudents();
                }}>
                <FontAwesomeIcon icon={faShieldKeyhole} className="lockUnlock" /> Lock/Unlock
              </button>
            </OverlayTrigger>
          )}
          <span>
            Number of questions in the assignment
            <span className="assignQuestionsCount">{result?.data?.questionsCount}</span>
          </span>
          <span className="ms-3">
            Number of students assigned
            <span className="assignQuestionsCount">
              {result?.data?.assignmentResults.filter((item) => !item.isRemoved).length}
            </span>
          </span>
        </div>
      </div>
      <div className="custom-table table-responsive">
        <UiVirtualScroll rowHeight={60} height="400px">
          <table className="table">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    value=""
                    id="flexCheckDefault"
                    name="allselect"
                    checked={
                      displayResults.length == 0
                        ? false
                        : displayResults?.filter((item) => item?.isChecked !== true).length < 1
                    }
                    onChange={handleAssignmentChecked}
                    defaultChecked={false}
                  />
                </th>
                <th>
                  Last Name{' '}
                  <button
                    className="sort-btn"
                    id="sort-lastName"
                    onClick={(e) => {
                      sortResultsBy.current = e.target.id;
                      handleAssignmentSort(e);
                    }}>
                    <FontAwesomeIcon icon={faSort} />
                  </button>
                </th>
                <th>
                  First Name{' '}
                  <button
                    className="sort-btn"
                    id="sort-firstName"
                    onClick={(e) => {
                      sortResultsBy.current = e.target.id;
                      handleAssignmentSort(e);
                    }}>
                    <FontAwesomeIcon icon={faSort} />
                  </button>
                </th>
                <th>
                  Class{' '}
                  <button
                    className="sort-btn"
                    id="sort-className"
                    onClick={(e) => {
                      sortResultsBy.current = e.target.id;
                      handleAssignmentSort(e);
                    }}>
                    <FontAwesomeIcon icon={faSort} />
                  </button>
                </th>
                <th>
                  <FontAwesomeIcon icon={faCheck} />
                </th>
                <th>
                  <FontAwesomeIcon icon={faX} />
                </th>
                <th>
                  <FontAwesomeIcon icon={faX} />
                  <FontAwesomeIcon icon={faCheck} />
                </th>
                <th className="text-center text-pre">
                  CR
                  <br />
                  Answered{' '}
                  <button
                    className="sort-btn"
                    id="sort-crAnsweredCount"
                    onClick={(e) => {
                      sortResultsBy.current = e.target.id;
                      handleAssignmentSort(e);
                    }}>
                    <FontAwesomeIcon icon={faSort} />
                  </button>
                </th>
                <th className="text-center text-pre">
                  Original
                  <br />
                  Score{' '}
                  <button
                    className="sort-btn"
                    id="sort-rawScore"
                    onClick={(e) => {
                      sortResultsBy.current = e.target.id;
                      handleAssignmentSort(e);
                    }}>
                    <FontAwesomeIcon icon={faSort} />
                  </button>
                </th>
                <th className="text-center text-pre">
                  Accumulated
                  <br />
                  Retake Score
                  <button
                    className="sort-btn"
                    id="sort-retakeBestScore"
                    onClick={(e) => {
                      sortResultsBy.current = e.target.id;
                      handleAssignmentSort(e);
                    }}>
                    <FontAwesomeIcon icon={faSort} />
                  </button>
                </th>
                <th className="text-center text-pre">
                  Date
                  <br />
                  Assigned{' '}
                  <button
                    className="sort-btn"
                    id="sort-dateAssigned"
                    onClick={(e) => {
                      sortResultsBy.current = e.target.id;
                      handleAssignmentSort(e);
                    }}>
                    <FontAwesomeIcon icon={faSort} />
                  </button>
                </th>
                <th className="text-center text-pre">
                  Date
                  <br />
                  Started{' '}
                  <button
                    className="sort-btn"
                    id="sort-dateStarted"
                    onClick={(e) => {
                      sortResultsBy.current = e.target.id;
                      handleAssignmentSort(e);
                    }}>
                    <FontAwesomeIcon icon={faSort} />
                  </button>
                </th>
                <th className="text-center text-pre">
                  Date
                  <br />
                  Completed{' '}
                  <button
                    className="sort-btn"
                    id="sort-dateCompleted"
                    onClick={(e) => {
                      sortResultsBy.current = e.target.id;
                      handleAssignmentSort(e);
                    }}>
                    <FontAwesomeIcon icon={faSort} />
                  </button>
                </th>
                <th className="text-center text-pre">
                  Retakes
                  <br />
                  Issued
                </th>
                <th className="text-center text-pre">Lock</th>
                <th className="text-center text-pre">
                  Details {/*<FontAwesomeIcon icon={faCircleQuestion} color="#88CBF1" />*/}
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {result.isError && (
                <tr>
                  <td colSpan="16" style={{ textAlign: 'center' }}>
                    <button
                      style={{
                        color: '#F84646',
                        fontSize: '1.15rem',
                        border: 'none',
                        background: 'none'
                      }}
                      onClick={() => refetch()}>
                      There was an error getting the data. Click to try again
                    </button>
                  </td>
                </tr>
              )}
              {result.isFetching && (
                <tr>
                  <td colSpan="15">
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: '40px' }}>
                      <HesSpinner />
                      <span className="ms-3">Loading results...</span>
                    </div>
                  </td>
                </tr>
              )}
              {!result.isFetching &&
                result.isSuccess &&
                (displayResults.length == 0 ||
                  displayResults.filter((item) => selectedClassIds.includes(item.classId)).length ==
                  0 ||
                  (!showRemovedStudents &&
                    displayResults.filter((item) => !item.isRemoved).length == 0)) && (
                <tr>
                  <td colSpan="16">
                    <div
                      className="d-flex align-items-end justify-content-center text-align-center"
                      style={{
                        backgroundImage: `url(${StudentClipboardImg})`,
                        backgroundRepeat: 'no-repeat',
                        height: '130px',
                        backgroundPositionX: 'center'
                      }}>
                      {displayResults.length == 0 ||
                          (!showRemovedStudents &&
                            displayResults.filter((item) => !item.isRemoved).length == 0) ? (
                          <span>There are no students assigned to this assignment</span>
                        ) : (
                          <span>{`There are no available students within the selected class${selectedClassIds.length === 1 ? '' : 'es'
                          }`}</span>
                        )}
                    </div>
                  </td>
                </tr>
              )}

              {displayResults &&
                displayResults.map((item, index) => {
                  if (
                    !selectedClassIds.includes(item.classId) ||
                    (!showRemovedStudents && item.isRemoved)
                  )
                    return;

                  let rawScore = 0;
                  switch (retryCreditId) {
                  case 0:
                    if (showPoints) {
                      rawScore = item.retriesAsNoCreditScore?.points;
                    } else {
                      rawScore = scoreUnansweredAsZero
                        ? item.retriesAsNoCreditScore?.percentUnansweredAsZero
                        : item.retriesAsNoCreditScore?.percent;
                    }
                    break;
                  case 1:
                    if (showPoints) {
                      rawScore = item.retriesAsHalfCreditScore?.points;
                    } else {
                      rawScore = scoreUnansweredAsZero
                        ? item.retriesAsHalfCreditScore?.percentUnansweredAsZero
                        : item.retriesAsHalfCreditScore?.percent;
                    }
                    break;
                  case 2:
                    if (showPoints) {
                      rawScore = item.retriesAsFullCreditScore?.points;
                    } else {
                      rawScore = scoreUnansweredAsZero
                        ? item.retriesAsFullCreditScore?.percentUnansweredAsZero
                        : item.retriesAsFullCreditScore?.percent;
                    }
                    break;
                  default:
                    if (showPoints) {
                      rawScore = item.retriesAsNoCreditScore?.points;
                    } else {
                      rawScore = scoreUnansweredAsZero
                        ? item.retriesAsNoCreditScore?.percentUnansweredAsZero
                        : item.retriesAsNoCreditScore?.percent;
                    }
                  }
                  let retakeResult = getRetakeScorePercentage(item);

                  return (
                    <tr key={`assignmentResult_${index}`}>
                      <td>
                        {' '}
                        <input
                          type="checkbox"
                          value=""
                          name={item.studentId}
                          checked={item?.isChecked || false}
                          onChange={handleAssignmentChecked}
                          className="form-check-input"
                          id={`flexCheckDefault${item.assignmentId}`}
                        />
                      </td>
                      <td>{ferpaEnabled ? item.studentLastName : 'hidden'}</td>
                      <td>{ferpaEnabled ? item.studentFirstName : 'hidden'}</td>
                      <td>{item.className}</td>
                      <td className="text-center">{item.correctCount}</td>
                      <td className="text-center">{item.incorrectCount}</td>
                      <td className="text-center">{item.correctOnRetryCount}</td>
                      <td className="text-center">{item.crAnsweredCount}</td>
                      <td className="text-center">{`${rawScore ?? (item.dateStarted ? '0' : 'Not Started')
                      } ${showPoints ? '' : item.dateStarted ? '%' : ''}`}</td>
                      <td className="text-center">{showPoints ? retakeResult.points : retakeResult.percent + '%'}</td>
                      <td className="text-center text-nowrap">
                        {item.dateAssigned
                          ? new Intl.DateTimeFormat('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          })
                            .format(new Date(item.dateAssigned))
                            .replace(/\//g, '-')
                          : ''}
                      </td>
                      <td className="text-center text-nowrap">
                        {item.dateStarted
                          ? new Intl.DateTimeFormat('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          })
                            .format(new Date(item.dateStarted))
                            .replace(/\//g, '-')
                          : ''}
                      </td>
                      <td className="text-center text-nowrap">
                        {item.dateCompleted
                          ? new Intl.DateTimeFormat('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          })
                            .format(new Date(item.dateCompleted))
                            .replace(/\//g, '-')
                          : item.timedOut
                            ? 'Timed Out'
                            : ''}
                      </td>
                      <td className="text-center">{item.retakeResults?.length ?? 'N/A'}</td>
                      <td>
                        <>
                          {item.assignmentOptions.disableLock ? (
                            <OverlayTrigger
                              key={`locked-${index}`}
                              placement="top"
                              overlay={
                                <Tooltip
                                  id={`tooltip-retakeResultsReport-${index}`}
                                  className="custom-tooltip">
                                  &apos;This assignment is locked until the student completes their
                                  retakes.&apos;
                                </Tooltip>
                              }>
                              <FontAwesomeIcon
                                disabled={true}
                                icon={faLockKeyhole}
                                className="disabledLock"
                              />
                            </OverlayTrigger>
                          ) : (
                            <OverlayTrigger
                              key={`locked-${index}`}
                              placement="top"
                              overlay={
                                <Tooltip
                                  id={`tooltip-retakeResultsReport-${index}`}
                                  className="custom-tooltip">
                                  {item.assignmentOptions.locked ? 'Locked' : 'Unlocked'}
                                </Tooltip>
                              }>
                              <FontAwesomeIcon
                                onClick={() => updateIndividualStudentLock(item.studentId)}
                                icon={
                                  item.assignmentOptions.locked ? faLockKeyhole : faLockKeyholeOpen
                                }
                                className="lockUnlock"
                              />
                            </OverlayTrigger>
                          )}
                        </>
                      </td>
                      <td>{generateAssignmentDetails(item.assignmentOptions, index, 4)}</td>

                      <td>
                        <div className="d-flex flex-row justify-content-end">
                          {item.retakeResults && (
                            <OverlayTrigger
                              key={`retakeResultsReport-${index}`}
                              placement="top"
                              overlay={
                                <Tooltip
                                  id={`tooltip-retakeResultsReport-${index}`}
                                  className="custom-tooltip">
                                  Retakes Results
                                </Tooltip>
                              }>
                              <div
                                onClick={() => {
                                  retakeModalData.current = item;
                                  retakeScore.current = retakeResult;
                                  setShowRetakesModal(true);
                                }}
                                className="assignmentOptions"
                                style={{ backgroundColor: '#F2E5FF', cursor: 'pointer' }}>
                                <FontAwesomeIcon icon={faRetweet} color="#9E5CDF" />
                              </div>
                            </OverlayTrigger>
                          )}

                          <OverlayTrigger
                            key={`reponsesReport-${index}`}
                            placement="top"
                            overlay={
                              <Tooltip
                                id={`tooltip-reponsesReport-${index}`}
                                className="custom-tooltip">
                                Responses
                              </Tooltip>
                            }>
                            <div
                              onClick={() =>
                                item.dateStarted
                                  ? navigate(`/responses/${item.assignmentId}/${item.studentId}`)
                                  : ''
                              }
                              className="assignmentOptions"
                              style={{ backgroundColor: '#F0F2F8', cursor: 'pointer' }}>
                              <FontAwesomeIcon icon={faMessagesQuestion} color="#525252" />
                            </div>
                          </OverlayTrigger>

                          <OverlayTrigger
                            key={`studentSessionReport-${index}`}
                            placement="top"
                            overlay={
                              <Tooltip
                                id={`tooltip-studentSessionReport-${index}`}
                                className="custom-tooltip">
                                Student Session Report
                              </Tooltip>
                            }>
                            <div
                              className="assignmentOptions"
                              onClick={() =>
                                item.dateStarted
                                  ? reportNavigateHandler(
                                    item.studentId,
                                    item.assignmentId,
                                    item.className,
                                    scoreUnansweredAsZero
                                  )
                                  : ''
                              }
                              style={{ backgroundColor: '#F0F2F8', cursor: 'pointer' }}>
                              <FontAwesomeIcon icon={faChartArea} color="#525252" />
                            </div>
                          </OverlayTrigger>

                          <OverlayTrigger
                            key={`uploadedFilesOverlay-${index}`}
                            placement="top"
                            overlay={
                              <Tooltip
                                id={`tooltip-uploadedFilesOverlay-${index}`}
                                className="custom-tooltip">
                                Student Uploaded Files
                              </Tooltip>
                            }>
                            <div
                              className="assignmentOptions bg-lightgray"
                              onClick={() => {
                                studentFilesModalData.current = {
                                  files: item.uploadedFiles,
                                  studentName: `${item.studentFirstName} ${item.studentLastName}`
                                };
                                item.uploadedFiles.length > 0 ? setShowStudentFilesModal(true) : '';
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faPaperclip}
                                className={item.uploadedFiles.length > 0 ? 'text-color-yellow' : 'text-color'}
                                cursor={item.uploadedFiles.length > 0 ? 'pointer' : ''}
                              />
                            </div>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </UiVirtualScroll>
      </div>

      <FloatingMenu floatingButtons={floatingMenuButtons} onClick={handleClick} />
      {retakeModalData?.current && (
        <RetakesModal
          assignmentResult={retakeModalData.current}
          show={showRetakesModal}
          onHide={() => setShowRetakesModal(false)}
          retakeScore={retakeScore.current}
        />
      )}

      <Modal
        show={showConfirmUnassignModal}
        onHide={() => setShowConfirmUnassignModal(false)}
        size="lg"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h1>Unassign Assignment</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center">
            <div
              style={{
                backgroundImage: `url(${ConfirmUnassign})`,
                backgroundRepeat: 'no-repeat',
                height: '120px',
                width: '140px'
              }}></div>

            <div style={{ fontSize: '1rem', fontWeight: '600' }}>
              Are you sure that you want to unassign the assignment from the checked students?
            </div>
            <div className="my-3 text-center">
              By unassigning from students who have started the assignment, you will no longer be
              able to view their results for this assignment.
            </div>

            <div className="d-flex flex-row justify-content-evenly w-50">
              <Button
                className="w-50"
                variant="castleGray"
                onClick={() => setShowConfirmUnassignModal(false)}>
                No
              </Button>
              <Button
                className="ms-3 w-50"
                variant="castleRed"
                onClick={() => handleUnassignStudents()}
                disabled={unassignStudentsResult.isLoading}>
                Yes
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showConfirmReviewModal}
        onHide={() => setShowConfirmReviewModal(false)}
        size="lg"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h1>Confirm</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center">
            <div className="my-3" style={{ fontSize: '1rem', fontWeight: '600' }}>
              Are you sure you want to set the original assignments and retakes to review?
            </div>

            <div className="d-flex flex-row justify-content-even w-50">
              <Button
                className="w-50"
                variant="castleGray"
                onClick={() => setShowConfirmReviewModal(false)}>
                No
              </Button>
              <Button
                className="ms-3 w-50"
                variant="castleRed"
                onClick={() => handleSetAssignmentToReview()}
                disabled={setAssignmentToReviewResults.isLoading}>
                Yes
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default AssignmentResults;
